'use strict';

import React, {Component} from "react";
import {observer} from "mobx-react";

import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import {States} from '@uw-it-sis/lib-react/lib/AppConstants';
import Broken from '@uw-it-sis/lib-react/lib/Broken';
import UnknownState from '@uw-it-sis/lib-react/lib/UnknownState';
import SimpleState from '@uw-it-sis/lib-react/lib/SimpleState';
import Loader from "@uw-it-sis/lib-react/lib/Loader";

import planSharedSelectorStore from './PlanSharedSelectorStore';

/**
 * Allows the user to mark their MyPlan plan as Shared or Private.
 */
class PlanSharedSelector extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.store = planSharedSelectorStore;
    }

    componentDidMount() {
        this.store.loadSharedPlanData();
    }

    /**
     * Handle radio button changes.
     */
    onChange = (e) => {
        let value = e.target.value;
        this.store.updatePlanSharedState(value);
    }

    buildDoneComponent = () => {
        let component =
            <form>
                <fieldset role="group">
                    <Form.Group as={Row} className="mb-0">
                        <Form.Label as="legend" column xs={12} className="py-0 fw-bolder">Shared view of your academic plan</Form.Label>
                        <Col xs={12}>
                            <p>When shared, UW advisers can view and add recommendations to your plan. Private plans are only viewable by you.</p>
                            <Form.Check
                                id="plan-sharing-enabled"
                                value={true}
                                checked={this.store.isPlanShared}
                                type="radio"
                                onChange={this.onChange}
                                label="Shared with UW advisers"/>
                            <Form.Check
                                id="plan-sharing-disabled"
                                value={false}
                                checked={!this.store.isPlanShared}
                                type="radio"
                                onChange={this.onChange}
                                label="Private"
                                className="mt-2"/>
                        </Col>
                    </Form.Group>
                </fieldset>
            </form>;

        return (
            <Loader show={this.store.state === States.pending}>
                {component}
            </Loader>
        );
    }

    render() {
        return <SimpleState state={this.store.state}
                            doneComponentBuilder={this.buildDoneComponent}
                            pendingComponentBuilder={this.buildDoneComponent}
                            name="PlanSharedSelector"/>
    }
}

export default observer(PlanSharedSelector);